import { render, staticRenderFns } from "./RegionalSelector.vue?vue&type=template&id=8d4445ac&"
import script from "./RegionalSelector.vue?vue&type=script&lang=js&"
export * from "./RegionalSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports